import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=ea54fbfa&scoped=true&"
import script from "./Tokens.vue?vue&type=script&lang=js&"
export * from "./Tokens.vue?vue&type=script&lang=js&"
import style0 from "./Tokens.vue?vue&type=style&index=0&id=ea54fbfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea54fbfa",
  null
  
)

export default component.exports